import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom';
import { Alert } from 'reactstrap';
// import { ACTIVE_PROFILE } from '../config';

// HOC
import withAppInitilizationChecks from '../HOC/withAppInitilizationChecks';

// Components
import Loading from '../components/Loading';

// Pages
import Home from './Home';
import ShopriteSSO from './ShopriteSSO'; // SSO redirect
import ShopriteSAML from './ShopriteSAML'; // SSO redirect
import WakefernSSO from './WakefernSSO'; // SSO redirect
import FAQ from './LegalDocuments/FAQ';
import TermsOfUse from './LegalDocuments/TermsOfUse';
import PrivacyPolicy from './LegalDocuments/PrivacyPolicy';

// App Pages
// import App from './App';
import Tutorial from './Tutorial';
import Account from './Account';
import Campaigns from './Campaigns';
import CampaignPage from './CampaignPage/index';

// For Development
import Login from './Login';
import Version from './Version';
import Demo from './Demo';
import TestSAML from './TestSAML';
import {Container} from "reactstrap";



const AppRoutes = ({ match }) => (
  <Switch>
    <Route path={`${match.url}/version`}               exact component={Version}  />
    <Route path={`${match.url}/tutorial`}              exact component={Tutorial}  />
    <Route path={`${match.url}/account`}               exact component={Account}   />
    <Route path={`${match.url}/campaigns`}             exact component={Campaigns} />
    <Route path={`${match.url}/campaigns/:campaignId`} exact component={CampaignPage} />
    <Redirect to={`${match.url}/campaigns`} />
  </Switch>
);


// Create Final App Routes
const AppRoutesWithInitializationChecks = withAppInitilizationChecks(AppRoutes);


const Routes = () => (
  <div>

    <Loading />

    <Router>
      <Switch>
        <Route path='/test-saml' component={TestSAML} />
        <Route path="/app"     component={AppRoutesWithInitializationChecks} />
        <Route path="/cds"     component={ShopriteSSO} exact /> {/* ShopRite redirects to /cds */}
        <Route path="/saml"    component={WakefernSSO} exact /> {/* ShopRite redirects to /saml */}
        <Route path="/privacy" component={PrivacyPolicy} exact />
        <Route path="/terms"   component={TermsOfUse} exact />
        <Route path="/faq"     component={FAQ} exact />
        <Route path="/"        component={Home} exact />

        {/* For Development */}
        <Route path="/demo"    component={Demo} exact />
        <Route path="/login"   component={Login} exact />
        {/* Show on all routes EXCEPT production */}
        {/* {(ACTIVE_PROFILE !== 'prod' && ACTIVE_PROFILE !== 'production') && (
          <Route path="/login"   component={Login} exact />
        )} */}

        <Redirect to="/" />
      </Switch>
    </Router>
  </div>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/pages/routes.js